import React, { useState } from 'react';
import Flex from '../Flex/Flex';
import Button from '../forms/Button/Button';
import IconEdit from '../icons/IconEdit';
import IconMastercard from '../icons/IconMastercard';
import IconVisa from '../icons/IconVisa';
import IconDiscover from '../icons/IconDiscover';
import IconCaromDown from '../icons/IconCaromDown';
import styles from './ResubscribeModal.module.css';

interface BillingInfoProps {
  cardType?: string;
  lastFour?: string;
  onEdit?: () => void;
  name?: string;
  expirationMonth?: string;
  expirationYear?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  startedOn?: string;
}

export const BillingInfo: React.FC<BillingInfoProps> = ({
  cardType,
  lastFour,
  onEdit = () => {},
  name = "Place Holder",
  expirationMonth = "11",
  expirationYear = "2029",
  address = "8 Place Holder STE 4000",
  city = "PlaceHolder",
  state = "DE",
  zipCode = "19904",
  country = "United States",
  startedOn = "Oct 25, 1997 12:56 PM"
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const getCardIcon = () => {
    switch (cardType?.toLowerCase()) {
      case 'visa':
        return <IconVisa />;
      case 'mastercard':
        return <IconMastercard />;
      case 'discover':
      case 'american express':
        return <IconDiscover />;
      default:
        return <IconMastercard />;
    }
  };

  return (
    <Flex direction="column" gap={2} className={styles.billingInfo}>
      <Flex direction="row" gap={2} align='center' justify='space-between'>
        <div className="strong">Billing Information</div>
        <div className={styles.row}>
          <div className={styles.value}>
            <span className={styles.cardInfo}>
              {getCardIcon()} -{lastFour || '2984'}
            </span>
          </div>
          <Button type="secondary" onClick={onEdit} className={styles.editButton}>
            Edit <IconEdit />
          </Button>
          <button
            className={styles.expandButton}
            onClick={() => setIsExpanded(!isExpanded)}
            aria-label={isExpanded ? "Collapse" : "Expand"}
          >
            <span style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', display: 'flex', transition: 'transform 0.2s' }}>
              <IconCaromDown />
            </span>
          </button>
        </div>
      </Flex>
      
      {isExpanded && (
        <Flex direction="column" gap={3} className={styles.expandedContent}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Name:</span>
            <span className={styles.detailValue}>{name}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Expiration:</span>
            <span className={styles.detailValue}>{expirationMonth}/{expirationYear}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Address:</span>
            <span className={styles.detailValue}>
              {address} {city}, {state} {zipCode} {country}
            </span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Started On:</span>
            <span className={styles.detailValue}>{startedOn}</span>
          </div>
        </Flex>
      )}
    </Flex>
  );
};

export default BillingInfo;